export default class Advert {
    id = null;
    name = '';
    active = false;
    buttonContent = '';
    budget = 0.0;
    provision = 0.0;
    mediaLength = 0;
    media = {};
    dateStart = null;
    dateEnd = null;
    advertType = '';
    fitScreen = true;
    tags = [];
    blackTags = [];
    excludedElevator = [];
    specificElevator = [];

    constructor() {
    }
  }
  